import { useEffect, useRef, useState } from 'react'
import Loader from 'react-loaders'
import AnimatedLetters from '../AnimatedLetters'
import './index.scss'
import emailjs from '@emailjs/browser'
import { MapContainer, Marker, Popup, TileLayer } from 'react-leaflet'

const Contact = () => {
    const [letterClass, setLetterClass] = useState('text-animate ');
    const form = useRef();
    useEffect(() => {
        setTimeout(()=>{
            setLetterClass('text-animate-hover')
        },3000)
    },[])
    const serviceID='service_iwubx6f';
    const templateID='template_3zcea3e';
    const publicKey='KSxtV4g6URKZv0vL6';
    const sendEmail = (e) => {
        e.preventDefault();

        emailjs.sendForm(
                serviceID,
                templateID,
                form.current,
                publicKey
            )
            .then(
                ()=>{
                    alert('Message successfully sent!')
                    window.location.reload(false)
                },
                (error) =>{
                    console.log(error.text);
                    alert('Failed to send the message, please try again')
                }
            )
    }

    return (
        <>
        <div className="container contact-page">
            <div className="text-zone">
                <h1>
                    <AnimatedLetters
                    letterClass={letterClass}
                     strArray={['C','o','n','t','a','c','t',' ','m','e']}
                    idx={15}
                    />
                </h1>
                <p>
                I am interested in freelance opportunities - especially on ambitious
            or large projects. However, if you have any other requests or
            questions, don't hesitate to contact me using below form either.
                </p>

                <div className="contact-form">
                    <form ref={form} onSubmit={sendEmail}>
                        <ul>
                            <li className="half">
                                <input type="text" name='name' placeholder='Name' required />
                            </li>
                            <li className="half">
                                <input type="email" name='email' placeholder='email' required />
                            </li>
                            <li>
                                <input type='text' placeholder='subject' name='subject' required />
                            </li>
                            <li>
                                <textarea name="message"  placeholder='Message' required></textarea>
                            </li>
                            <li>
                                <input type="submit" className='flat-button' value="SEND" />
                            </li>

                        </ul>
                    </form>
                </div>
            
            
            </div>
            <div className="info-map">
                Himanshu Verma,
                <br />
                India
                <br />
                Pragati nagar
                <br />
                hardoi, U.P 241001 <br />
                <span>himanshu_2019bele024@nitsri.net</span>
            </div>
            <div className="map-wrap">
                <MapContainer center={[27.3965, 80.1250]} zoom={13}>
                <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                <Marker position={[27.3965, 80.1250]}>
                    <Popup>Himanshu lives here, come over for a cup of coffee :)</Popup>
                </Marker>
                </MapContainer>
            </div>
        </div>
        <Loader type="pacman"/>
        </>
    )
}

export default Contact